import { Space, Tooltip } from 'antd'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import useFilter from 'hooks/useFilter'
import { useAppDispatch } from 'hooks/useRedux'
import useSearchDebounce from 'hooks/useSearchDebounce'
import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  useInvalidateQuery,
  useMutationExportExcel,
  useMutationRemove,
} from '../queries'
import { transactionActions, useTransactionSelector } from '../slice'
import '../styles.scss'
import CustomFilter from './CustomFilter'
import Utils, { checkAllStatusNotCreateInvoice } from 'general/utils/Utils'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import SearchFieldPopover, {
  getSearchFieldPlaceholder,
} from 'general/components/SearchFieldPopover'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'

const transactionSearchFieldGroups = [
  { key: 'saleNumber', fields: [{ label: 'Mã bơm', value: 'saleNumber' }] },
  { key: 'productName', fields: [{ label: 'Hàng hóa', value: 'productName' }] },
  {
    key: 'stationName',
    fields: [{ label: 'Trạm/cửa hàng', value: 'stationName' }],
  },
  { key: 'createdBy', fields: [{ label: 'Người tạo', value: 'sellerEmail' }] },
  { key: 'invoiceNo', fields: [{ label: 'Số HĐ', value: 'invoiceNo' }] },
]
const transactionSearchFields = transactionSearchFieldGroups.flatMap(
  (group) => group.fields,
)

export const normalizeTransactionSearchFields = (fields) =>
  [...new Set(Array.isArray(fields) ? fields : ['saleNumber'])].map((field) =>
    field === 'nozzleCode' ? 'saleNumber' : field,
  )

export default function TransactionHeader({ defaultColumns, dataSource }) {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  console.log('dataSource', dataSource)
  const { debouncedSearch, search, setSearch } = useSearchDebounce()
  const [filterParams, setFilterParams] = useFilter(
    'listTransactions',
    'gFilterListTransactions',
  )
  const { invalidate } = useInvalidateQuery()
  const { mutate: handleExport, isPending: isExportingExcel } =
    useMutationExportExcel(defaultColumns)
  const { selectedRows } = useTransactionSelector()
  const [inforRemove, setInforRemove] = useState({
    visible: false,
    value: [],
  })

  const getExportParams = () => {
    const searchValue = filterParams.q?.trim() ?? ''
    const searchField = normalizeTransactionSearchFields(
      filterParams.searchFields,
    ).join(',')

    return {
      ..._.omit(filterParams, ['page', 'limit', 'searchFields', 'q']),
      ...(searchField && searchValue
        ? { searchField, searchValue }
        : { q: searchValue }),
    }
  }

  function handleCombineExport() {
    dispatch(
      transactionActions.toggleModalState({
        name: 'combineExportInvoice',
        status: true,
      }),
    )
  }
  function handleMultipleExport() {
    dispatch(
      transactionActions.toggleModalState({
        name: 'multipleExportInvoice',
        status: true,
      }),
    )
  }
  // ============ EFFECTS ============

  useEffect(() => {
    if (filterParams.page)
      setFilterParams({
        q: debouncedSearch,
      })
  }, [debouncedSearch, filterParams.page, setFilterParams])

  const { mutate: removeHandleUnMarkInvoice } = useMutationRemove()

  const removeToggleMark = useCallback(
    (selectedRows, dataSource) => {
      if (checkAllStatusNotCreateInvoice(selectedRows, dataSource)) {
        removeHandleUnMarkInvoice({
          dataLogPetroId: selectedRows.map((item) => item.dataLogPetroId),
        })
      }
    },
    [dispatch, removeHandleUnMarkInvoice],
  )

  return (
    <ContentContainer.Header
      titleContent={t('listTransaction.name')}
      toolBar={
        <Space>
          {selectedRows.length > 0 && (
            <Space>
              <CustomAntButton
                iconCn="far fa-file-invoice"
                text={t('listTransaction.singleExport', {
                  quantity: selectedRows.length,
                })}
                antProps={{
                  type: 'default',

                  onClick: () => {
                    handleMultipleExport()
                  },
                }}
              />
              <CustomAntButton
                iconCn="far fa-files"
                text={t('listTransaction.mergedExport', {
                  quantity: selectedRows.length,
                })}
                antProps={{
                  type: 'default',

                  onClick: () => {
                    handleCombineExport()
                  },
                }}
              />
              {checkAllStatusNotCreateInvoice(selectedRows, dataSource) && (
                <CustomAntButton
                  iconCn="far fa-files"
                  text={t('listTransaction.removesExport', {
                    quantity: selectedRows.length,
                  })}
                  antProps={{
                    type: 'default',

                    onClick: () => {
                      setInforRemove({
                        visible: true,
                        value: selectedRows.map((item) => item.dataLogPetroId),
                      })
                      // handleCombineExport()
                    },
                  }}
                />
              )}
            </Space>
          )}

          <CustomAntButton
            iconCn="fas fa-file-arrow-down"
            text={t('listTransaction.exportToExcel')}
            isLoading={isExportingExcel}
            antProps={{
              type: 'primary',
              className: 'btn btn-success',
              onClick: () => {
                handleExport(getExportParams())
              },
            }}
          />
          <CustomAntButton
            iconCn="far fa-rotate"
            text="Làm mới dữ liệu"
            customStyle={{
              minWidth: 'auto',
            }}
            antProps={{
              type: 'default',
              onClick: () => {
                invalidate()
              },
            }}
          />
          <AppDnD
            defaultColumns={defaultColumns}
            localStorageName="gFilterListTransactions"
          />
        </Space>
      }
    >
      <Space wrap className="max-w-100" id="filter-content-wrapper">
        <SearchFieldPopover
          fields={transactionSearchFields}
          groups={transactionSearchFieldGroups}
          value={normalizeTransactionSearchFields(filterParams.searchFields)}
          onChange={(values) =>
            setFilterParams({ searchFields: values, page: 1 })
          }
        />
        <KTTooltip
          text={getSearchFieldPlaceholder(
            transactionSearchFields,
            transactionSearchFieldGroups,
            normalizeTransactionSearchFields(filterParams.searchFields),
          )}
        >
          <span>
            <CustomAntInput
              type="search"
              borderRadius="sm"
              width={150}
              inputProps={{
                placeholder: getSearchFieldPlaceholder(
                  transactionSearchFields,
                  transactionSearchFieldGroups,
                  normalizeTransactionSearchFields(filterParams.searchFields),
                ),
                style: { textOverflow: 'ellipsis' },
                value: search,
                onChange: (e) => setSearch(e.target.value),
              }}
            />
          </span>
        </KTTooltip>
        <CustomFilter />
      </Space>
      <ModalConfirm
        header="Xác nhận"
        content="Quý khách có chắc chắn muốn xóa log bơm này không?"
        contentDetails="Quý khách sẽ tự chịu trách nhiệm khi xóa log bơm này."
        show={inforRemove.visible}
        setShow={(status) => {
          setInforRemove({
            visible: status,
            value: null,
          })
          // dispatch(
          //   setModalsState({
          //     modalName: 'delete',
          //     status,
          //   }),
          // )
        }}
        handleConfirm={(e) => {
          removeToggleMark(selectedRows, dataSource)
          e.preventDefault()
          // deleteInvoiceMutation({
          //   invoices:
          //     selectedInvoices.length > 0 ? selectedInvoices : [activeInvoice],
          // })
        }}
      />
    </ContentContainer.Header>
  )
}
